<template>
  <div>
    <el-carousel :interval="3000">
      <el-carousel-item v-for="(item, index) in lunboImg" :key="index">
        <img :src="item.url" alt="" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'loopImg',
  data() {
    return {
      lunboImg: [{ url: require('../../static/homeBannerMobile.png') }],
      lang: 'zh',
    };
  },
  created() {
    this.lang = localStorage.getItem('lang');
  },
  methods: {},
  watch: {
    lang(newVal, oldVal) {
      if (newVal == 'en') {
        this.lunboImg = [{ url: require('../../static/英文-首屏头图.jpg') }];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loop {
  max-width: 100vw;
}
.el-carousel__item {
  color: #475669;
  font-size: 18px;
  margin: 0;
  height: 46vw;
}
.el-carousel__item > img {
  // min-width:100%;
  height: 46vw;
  display: block;
  margin: 0 auto;
}
.el-carousel__item:nth-child {
  height: 46vw;
  background: linear-gradient(180deg, #000000 0%);
  opacity: 0.4;
}
.el-carousel--horizontal {
  height: 46vw;
}
</style>
<style scoped>
.el-carousel__indicator >>> .el-carousel__button {
  /*background-color: #fff;*/
  width: 10px !important;
  height: 10px !important;
  /*background: #fccf00;*/
  border-radius: 50%;
}
.el-carousel >>> .el-carousel__item {
  display: flex !important;
  justify-content: center !important;
}
.el-carousel >>>  .el-carousel__container{
  height: 46vw;
}
</style>
<style>
.el-carousel__button {
  width: 10px !important;
  height: 10px !important;
  /*background: #fccf00 !important;*/
  border-radius: 50%;
}
.el-carousel__indicator.is-active .el-carousel__button {
  background: #fccf00 !important;
}
</style>
